export default __webpack_public_path__ + "static/media/395.cf34088b.gif";